import ButtonExport from './src/main'

ButtonExport.install = function (Vue) {
    Vue.components(ButtonExport.name, ButtonExport)
}

export default ButtonExport